// @ts-nocheck
import React, { useContext, useEffect, useState, useCallback } from 'react';
import Context from '../../context/Context';
import { fetchForm } from '../../context/forms/FormsAction';
import { useDropzone } from 'react-dropzone';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { resolveMediaUrl, URL } from '../../service/Service';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ImageIcon from '@mui/icons-material/Image';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const getUserRole = () => {
    try {
        const token = sessionStorage.getItem('jwt');
        if (!token) return 'USER';
        return jwtDecode(token)?.authorities?.[0]?.authority ?? 'USER';
    } catch (_error) {
        return 'USER';
    }
};

const StepHeader = ({ onBack, onFinish }) => {
    const steps = [
        { label: 'Editor', description: 'Campos do formulário' },
        { label: 'Definições', description: 'Pagamentos e regras' },
        { label: 'Upload Imagem', description: 'Marca e publicação' },
    ];

    return (
        <div className="sticky top-0 z-30 -mx-5 -mt-5 border-b border-slate-200 bg-slate-50/95 px-5 py-4 backdrop-blur">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">Publicação</p>
                    <h1 className="mt-1 text-2xl font-bold text-slate-900">Imagem e finalização</h1>
                    <p className="mt-1 text-sm text-slate-500">A imagem é opcional. Quando estiver tudo pronto, finaliza e regressa à lista de formulários.</p>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-100"
                        onClick={onBack}
                        type="button"
                    >
                        <ArrowBackIcon fontSize="small" />
                        Anterior
                    </button>
                    <button
                        className="inline-flex items-center gap-2 rounded-xl bg-green-cl px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-opacity-90"
                        onClick={onFinish}
                        type="button"
                    >
                        <RocketLaunchIcon fontSize="small" />
                        Finalizar
                    </button>
                </div>
            </div>

            <div className="mt-5 grid gap-3 md:grid-cols-3">
                {steps.map((step, index) => {
                    const current = index === 2;
                    const done = index < 2;

                    return (
                        <div
                            key={step.label}
                            className={`rounded-2xl border p-4 transition ${current ? 'border-emerald-700 bg-white shadow-sm' : done ? 'border-emerald-100 bg-emerald-50' : 'border-slate-200 bg-white'}`}
                        >
                            <div className="flex items-center gap-3">
                                <div className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${current ? 'bg-green-cl text-white' : done ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`}>
                                    {index + 1}
                                </div>
                                <div>
                                    <p className="text-sm font-bold text-slate-900">{step.label}</p>
                                    <p className="text-xs text-slate-500">{step.description}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const Toast = ({ type = 'success', title, message, onClose }) => {
    if (!message) return null;

    const styles = type === 'error'
        ? 'border-red-200 bg-red-50 text-red-700'
        : 'border-emerald-200 bg-emerald-50 text-emerald-700';

    return (
        <div className="fixed bottom-5 right-5 z-50 w-[min(440px,calc(100vw-2rem))]">
            <div className={`rounded-2xl border px-5 py-4 shadow-xl ${styles}`}>
                <div className="flex items-start justify-between gap-4">
                    <div>
                        <p className="text-sm font-bold">{title}</p>
                        <p className="mt-1 text-sm">{message}</p>
                    </div>
                    <button className="text-lg leading-none opacity-70 hover:opacity-100" type="button" onClick={onClose}>×</button>
                </div>
            </div>
        </div>
    );
};

const FormWizard3 = () => {
    const { state, dispatch } = useContext(Context);
    const { form } = state;
    const { idform } = useParams();
    const [fileName, setFileName] = useState('');
    const [URI, setURI] = useState('');
    const [file, setFile] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [uploading, setUploading] = useState(false);
    const token = sessionStorage.getItem('jwt');
    const userRole = getUserRole();
    const location = useLocation();
    const navigate = useNavigate();
    const isAdmin = userRole === 'ADMIN';
    const baseFormPath = isAdmin ? `/admin/forms/${idform}` : `/forms/${idform}`;
    const formsListPath = `${isAdmin ? '/admin/forms' : '/forms'}?form=${encodeURIComponent(idform)}`;

    const fetchPresignedImageUrl = useCallback(async () => {
        if (!token) return;

        try {
            const response = await axios.get(`${URL}/getPresignedUrl/${idform}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200 && response.data) {
                setURI(resolveMediaUrl(response.data));
            }
        } catch (error) {
            console.error('Could not fetch presigned URL for image', error);
        }
    }, [idform, token]);

    useEffect(() => {
        if (!token) return;

        async function fetchData() {
            try {
                const url = `${URL}/api/forms/${idform}`;
                await fetchForm(url, {}, dispatch);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        }

        fetchData();
    }, [dispatch, idform, token]);

    useEffect(() => {
        if (form?.data?.logo) {
            fetchPresignedImageUrl();
        }
    }, [form?.data?.logo, fetchPresignedImageUrl]);

    useEffect(() => {
        const isAdminPath = location.pathname.startsWith('/admin/forms/');
        const isFormWizardPath = location.pathname.endsWith('/formwizard/3');

        if (isAdminPath && isFormWizardPath && userRole !== 'ADMIN') {
            navigate('/login');
        }
    }, [location.pathname, navigate, userRole]);

    const handleFinalizar = () => {
        setSuccessMessage('Formulário finalizado com sucesso. A regressar à lista...');
        setTimeout(() => {
            navigate(formsListPath, {
                state: {
                    formCreationSuccess: true,
                    formName: form?.data?.name || 'Formulário',
                },
            });
        }, 800);
    };

    const uploadFileToForm = useCallback(async () => {
        if (!file) {
            setErrorMessage('Seleciona uma imagem antes de enviar.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        const url = `${URL}/uploadFile/${idform}`;
        setUploading(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                await fetchPresignedImageUrl();
                setSuccessMessage('Imagem enviada com sucesso.');
                setFile(null);
                setFileName('');
            } else {
                setErrorMessage(`Falha ao enviar imagem. Código: ${response.status}`);
            }
        } catch (error) {
            console.error(error);
            const backendMessage = error?.response?.data;
            setErrorMessage(
                typeof backendMessage === 'string' && backendMessage.trim()
                    ? backendMessage
                    : 'Não foi possível enviar a imagem para o backend. Tenta novamente.',
            );
        } finally {
            setUploading(false);
        }
    }, [file, idform, token, fetchPresignedImageUrl]);

    const removeLogo = useCallback(async () => {
        if (!token) return;

        setErrorMessage('');
        setSuccessMessage('');

        try {
            const url = `${URL}/api/forms/${idform}/image`;
            const response = await axios.delete(url, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 204) {
                setURI('');
                setSuccessMessage('Imagem removida do formulário e do armazenamento.');
            } else {
                setErrorMessage('Não foi possível remover a imagem.');
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Não foi possível remover a imagem.');
        }
    }, [idform, token]);

    const onDrop = useCallback((acceptedFiles) => {
        const selectedFile = acceptedFiles?.[0];
        if (!selectedFile) return;

        setFile(selectedFile);
        setFileName(selectedFile.name);
        setErrorMessage('');
    }, []);

    const handleCancel = useCallback(() => {
        setFile(null);
        setFileName('');
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': ['.jpg', '.jpeg', '.png', '.bmp', '.webp'],
        },
        multiple: false,
    });

    return (
        <div className="min-h-screen bg-slate-50 p-5 text-slate-900">
            <StepHeader
                onBack={() => navigate(`${baseFormPath}/formwizard/2`)}
                onFinish={handleFinalizar}
            />

            <div className="mt-6 grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_360px]">
                <main className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                    <div className="mb-6 flex items-start gap-4">
                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700">
                            <CloudUploadIcon />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-slate-900">Imagem do formulário</h2>
                            <p className="mt-1 text-sm text-slate-500">Usa uma imagem simples, leve e legível. Ideal para logótipo, banner ou identificação visual do evento.</p>
                        </div>
                    </div>

                    {URI && URI !== '' && (
                        <div className="mb-6 rounded-3xl border border-slate-200 bg-slate-50 p-4">
                            <div className="relative flex min-h-64 items-center justify-center rounded-2xl bg-white p-6 shadow-inner">
                                <img
                                    className="max-h-72 max-w-full rounded-xl object-contain"
                                    src={URI}
                                    alt="Imagem atual do formulário"
                                    onError={() => setURI('')}
                                />
                                <button
                                    type="button"
                                    onClick={removeLogo}
                                    className="absolute right-4 top-4 inline-flex items-center gap-2 rounded-xl bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700"
                                >
                                    <DeleteForeverIcon fontSize="small" />
                                    Remover
                                </button>
                            </div>
                        </div>
                    )}

                    <div
                        {...getRootProps()}
                        className={`cursor-pointer rounded-3xl border-2 border-dashed p-10 text-center transition ${isDragActive ? 'border-emerald-500 bg-emerald-50' : 'border-slate-300 bg-slate-50 hover:border-emerald-300 hover:bg-emerald-50/50'}`}
                    >
                        <input {...getInputProps()} />
                        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-white text-emerald-700 shadow-sm">
                            <ImageIcon fontSize="large" />
                        </div>
                        {isDragActive ? (
                            <p className="mt-5 text-base font-bold text-emerald-700">Larga a imagem aqui</p>
                        ) : fileName ? (
                            <div className="mt-5">
                                <p className="text-base font-bold text-slate-900">{fileName}</p>
                                <p className="mt-1 text-sm text-slate-500">Imagem pronta para envio.</p>
                            </div>
                        ) : (
                            <div className="mt-5">
                                <p className="text-base font-bold text-slate-900">Arrasta uma imagem para aqui</p>
                                <p className="mt-1 text-sm text-slate-500">ou clica para escolher um ficheiro JPG, PNG, BMP ou WEBP.</p>
                            </div>
                        )}
                    </div>

                    <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
                        {file && (
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
                                disabled={uploading}
                            >
                                Cancelar seleção
                            </button>
                        )}
                        <button
                            type="button"
                            onClick={uploadFileToForm}
                            className="rounded-xl bg-green-cl px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-opacity-90 disabled:cursor-not-allowed disabled:bg-slate-400"
                            disabled={uploading || !file}
                        >
                            {uploading ? 'A enviar...' : 'Enviar imagem'}
                        </button>
                    </div>
                </main>

                <aside className="space-y-5">
                    <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                        <div className="flex items-center gap-3">
                            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700">
                                <CheckCircleIcon />
                            </div>
                            <div>
                                <h3 className="font-bold text-slate-900">Estado</h3>
                                <p className="text-xs text-slate-500">Imagem opcional</p>
                            </div>
                        </div>

                        <div className="mt-5 space-y-2 text-sm">
                            <div className="flex justify-between rounded-2xl bg-slate-50 px-4 py-3">
                                <span className="text-slate-600">Imagem atual</span>
                                <span className={URI ? 'font-bold text-emerald-700' : 'font-bold text-slate-500'}>{URI ? 'Existe' : 'Sem imagem'}</span>
                            </div>
                            <div className="flex justify-between rounded-2xl bg-slate-50 px-4 py-3">
                                <span className="text-slate-600">Ficheiro escolhido</span>
                                <span className={file ? 'font-bold text-emerald-700' : 'font-bold text-slate-500'}>{file ? 'Sim' : 'Não'}</span>
                            </div>
                        </div>
                    </section>

                    <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                        <h3 className="font-bold text-slate-900">Boas práticas</h3>
                        <ul className="mt-4 space-y-3 text-sm leading-6 text-slate-600">
                            <li>Usa imagem leve para não atrasar o carregamento.</li>
                            <li>Evita texto pequeno dentro da imagem.</li>
                            <li>Confirma o contraste em mobile.</li>
                            <li>Podes finalizar sem imagem se o formulário for simples.</li>
                        </ul>
                    </section>
                </aside>
            </div>

            <Toast
                type="success"
                title="Sucesso"
                message={successMessage}
                onClose={() => setSuccessMessage('')}
            />
            <Toast
                type="error"
                title="Erro"
                message={errorMessage}
                onClose={() => setErrorMessage('')}
            />
        </div>
    );
};

export default FormWizard3;
